import {FC, memo} from 'react';
import {Box} from '@chakra-ui/react';
import {Svg} from 'ui-kit';

interface IProps {
  onOpenMenu: () => void;
}

const MenuButtonFC: FC<IProps> = ({onOpenMenu}) => {
  return (
    <Box
      p={'2px'}
      bg={'{colors.white}'}
      borderRadius={'50%'}
      position={'absolute'}
      overflow={'hidden'}
      boxShadow={'{shadows.shadow_menu}'}
      _hover={{cursor: 'pointer', opacity: 0.9}}
      onClick={onOpenMenu}
      left={'18px'}
      top={'10px'}
      zIndex={11}
    >
      <Box overflow={'hidden'} borderRadius={'4px'}>
        <Svg name={'Logo'} size={'s40'} />
      </Box>
    </Box>
  );
};

export const MenuButton = memo(MenuButtonFC);
